// extracted by mini-css-extract-plugin
export default {"filterIcon":"UserManagement_filterIcon__tvirJ","add-icon":"UserManagement_add-icon__s6D18","icon-24":"UserManagement_icon-24__7NO6m"};